/* eslint-disable no-unused-vars */
import React from 'react';
import { Box, Button, Menu, MenuItem, useTheme } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface OwnProps {
  readonly options: any[];
  readonly label: any;
  readonly getMenuItemLabel: (object: any) => string;
  readonly getValue: (object: any) => string | any;
  readonly handleClick: (amount: any) => void;
  readonly backgroundColorOverride?: string;
}

type Props = OwnProps;

const SelectComponent = (props: Props) => {
  const {
    label,
    options,
    handleClick,
    getMenuItemLabel,
    getValue
  } = props;
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (value: any) => {
    handleClick(value);
    handleClose();
  }

  return (
    <Box style={{ width: '100%' }} data-filter="offer-category">
      <Button
        sx={{
          height: 40,
          minWidth: 125,
          width: '100%',
          maxWidth: '100% !important',
          [theme.breakpoints.down('sm')]: {
            width: '100%',
          },
          justifyContent: 'space-between !important',
          textTransform: 'capitalize !important',
          padding: '4px 12px !important',
          backgroundColor: theme.palette.grey[300],
          border: `1px solid ${theme.palette.grey[300]}`,
          color: theme.palette.common.white,
          fontWeight: 500,
          fontSize: 13,
          '&.MuiButton-outlinedPrimary': {
            color: theme.palette.common.white
          },
          '& .MuiSvgIcon-root': {
            color: theme.palette.common.white,
          },
          '&.selected': {
            backgroundColor: theme.palette.grey[700],
            color: theme.palette.getContrastText(theme.palette.grey[700]),
            fontWeight: 500,
          },
          '&.disabled': {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.getContrastText(theme.palette.grey[100]),
            fontWeight: 500,
          },
        }}
        aria-controls="button-menu"
        aria-haspopup="true"
        variant="outlined"
        color="primary"
        style={{
          backgroundColor: props.backgroundColorOverride,
          border: '0px'
        }}
        onClick={handleOpen}
        endIcon={<ArrowDropDownIcon color="secondary" />}
      >
        {label}
      </Button>
      <Menu
        sx={{
          '& .MuiButtonBase-root': {
            justifyContent: 'flex-start',
            padding: '4px 12px',
          },
          '& .MuiPaper-root': {
            maxWidth: '100%',
            border: '1px solid #d3d4d5',
          },
          '& ul': {
            display: 'flex',
            flexDirection: 'column',
          },
          '& .row': {
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'row',
            alignItems: 'center',
            '& .team': {
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'row',
              alignItems: 'center',
              whiteSpace: 'nowrap',
              [theme.breakpoints.down('sm')]: {
                width: '100%',
                whiteSpace: 'inherit',
              },
              '& .img-wrapper': {
                width: 20,
                height: 20,
                marginRight: '6px',
                padding: '2px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 2,
                '& img': {
                  height: '100%',
                  width: '100%',
                  objectFit: 'contain',
                },
              },
              '& p': {
                fontWeight: 500,
              },
            },
          },
        }}
        // id="customized-menu"
        anchorEl={anchorEl}
        // keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options?.map((l: any, index: number) => (
          <MenuItem
            sx={{
              fontWeight: 500,
              fontSize: '0.875rem',
              '& .MuiListItemText-dense': {
                marginTop: '2px',
                marginBottom: '2px',
              },
            }}
            value={getValue(l)}
            key={label + index}
            onClick={() => handleMenuClick(getValue(l))}
            dense
          >
            {getMenuItemLabel(l)}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default SelectComponent;